<script>
	export let songs;
	export let lists;

	$: averageDelay = function () {
		const list = lists[1].list;
		if (!list.length)
			return -1;
		const now = Date.now();
		const sum = list.reduce((v, s) => v + (s.last ? s.dayDelay(now) : 0), 0);
		return Math.round(10 * sum / list.length) / 10;
	}();

	$: remainingStars = lists[1].list.reduce((v, s) => v + 5 - s.stars, 0);

</script>

<style>
	div {
		text-align: center;
	}
</style>

<div>
{songs.length} songs in da list!
{#if averageDelay != -1} průměrné opakování hotových: {averageDelay} dní, {/if}
{#if remainingStars} hvězd k vylepšení: {remainingStars} {/if}
</div>
